import { defineMessages } from "react-intl";

const messages = defineMessages({
    tempo: {
        id: "tasks.tempo",
    },
});

export default messages;
